<!-- 该文件取值以【components/processEvidence/index.vue】为准 -->
<template>
  <div class="evi-chain-root-sty">
    <div class="chain-header">
      <img class="logo-img-sty" src="/images/logo/u123.png" alt="君子签">
      <h1>电子签约全证据链</h1>
      <h2>FULL EVIDENCE CHAIN OF ELECTRONIC CONTRACTING</h2>
    </div>
    <!-- content -->
    <div class="chain-content-sty">
      <!-- 文件信息 -->
      <template>
        <p class="tip-title-sty">
          <span class="tip-icon"></span>
          <span class="title-sty">文件信息</span>
          <span class="line"></span>
        </p>
        <div class="info-sty">
          <p><span>主题名称</span><span class="font-bolder font-red">{{ contractInfo.contractName }}</span></p>
          <p><span>签约编号</span><span class="font-red">{{ contractInfo.applyNo }}</span></p>
          <p><span>文件名称</span><span>{{ contractInfo.contractName }}</span></p>
          <p><span>发起时间</span><span>{{ contractInfo.createTime | formatDateTime }}</span></p>
          <p><span>文件来源</span><span>{{ contractInfo.ebqUserName }}</span></p>
          <p><span>创建方式</span><span>{{ contractInfo.createType == 1 ? 'WEB' : 'API' }}</span></p>
        </div>
      </template>
      <!-- 发起方信息 -->
      <template>
        <p class="tip-title-sty">
          <span class="tip-icon"></span>
          <span class="title-sty">发起方信息</span>
          <span class="line"></span>
        </p>
        <div v-for="item of applySignRecord.filter(v => [14].includes(v.signType))" :key="item.id" class="info-sty">
          <p><span>名称</span><span class="font-bolder font-red">{{ item.name }}</span></p>
          <p><span>证件号</span><span class="font-red">{{ item.identityCard }}</span></p>
          <p><span>终端ip</span><span>{{ item.ip }}</span></p>
          <p><span>发起时间</span><span>{{ item.createTime }}</span></p>
          <p 
            style="
              width: 100%;
              white-space: normal;
              word-break: break-all;
            "
          ><span>地址</span><span>{{ item.url }}</span></p>
        </div>
      </template>
      <!-- 签署方信息 -->
      <template v-if="signtorList.length">
        <p class="tip-title-sty">
          <span class="tip-icon"></span>
          <span class="title-sty">签署方信息</span>
          <span class="line"></span>
        </p>
        <div class="signatory-sty">
          <div
            v-for="sign of signtorList"
            :key="sign.id"
            class="signatory-item-sty"
          >
            <div class="type-header-sty">
              <div class="type-icon-sty" :class="[sign.userType && sign.userType == 1 ? 'ent-sty' : 'person-sty']">
                {{ sign.userType && sign.userType == 1 ? '企业' : '个人'}}
              </div>
              <div>
                <p>{{ sign.name }}</p>
                <p>证件号：{{ sign.identityCard }}</p>
              </div>
            </div>
            <template v-if="registShow(sign).length > 0">
              <p class="title-ii-sty">注册认证信息</p>
              <div v-for="(reco,i) of registShow(sign)" :key="i" class="sign-info-sty">
                <el-row>
                  <el-col :span="6">认证方式</el-col>
                  <el-col :span="18" class="font-bolder font-red">{{ fluStatus(reco.authType, reco.userType) }}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">认证时间</el-col>
                  <el-col :span="18">{{ reco.authDate }}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">流水号</el-col>
                  <el-col :span="18" style="color:#e76177;">{{ reco.orderNo }}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">认证结果</el-col>
                  <el-col :span="18">
                    <span class="auth-res-sty">
                      <span v-if="reco.authType == 1 && reco.context">{{ `匹配百分比：${parseFloat(reco.context).toFixed(2)}%，` }}</span>
                      <span class="auth-statu-sty">认证通过</span>
                    </span>
                  </el-col>
                </el-row>
              </div>
            </template>
            <el-empty v-else description="暂无注册认证信息" :image-size="40"></el-empty>
          </div>
        </div>
      </template>
      <!-- 签署流程时间线 -->
      <template v-if="signatoryNotifys.length">
        <p class="tip-title-sty">
          <span class="tip-icon"></span>
          <span class="title-sty">签署流程时间线</span>
          <span class="line"></span>
        </p>
        <el-timeline>
          <el-timeline-item
            v-for="(item, i) in signatoryNotifys"
            :key="i"
          >
            <template slot="dot">
              <i class="dot-sty"></i>
            </template>
            <div class="signing-process-sty" :class="item.className">
              <el-row class="signing-header-sty header-type-sty">
                <el-col :span="4" style="text-align: center;"><span class="header-title">{{ item.label }}</span></el-col>
                <el-col :span="14">
                  <span v-show="item.signType !== 24 && item.name" class="font-bolder">{{ item.name }}</span>
                  <span v-show="item.signType !== 24 && item.identityCard" class="card-num-sty">{{ item.identityCard }}</span>
                </el-col>
                <el-col :span="6" style="text-align: right;font-weight: bolder;padding-right: 20px;">{{ item.createTime }}</el-col>
              </el-row>
              <div class="sign-content-sty">
                <!-- 创建签约展示 -->
                <template v-if="item.signType == 14">
                  <el-row>
                    <el-col :span="4">创建时间</el-col>
                    <el-col :span="20">{{ item.createTime }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">终端IP</el-col>
                    <el-col :span="20">{{ item.ip }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">地址</el-col>
                    <el-col 
                      :span="20" 
                      style="
                        white-space: normal;
                        word-break: break-all;
                      "
                    >{{ item.url }}</el-col>
                  </el-row>
                  <template v-if="item.readTimeSignInfoList && item.readTimeSignInfoList.length">
                    <el-row v-for="(childItem, childIndex) in item.readTimeSignInfoList" :key="'xxx'+ childIndex">
                      <el-col :span="4"></el-col>
                      <el-col :span="20">发起方给签署方（{{childItem.name}}）设置了{{childItem.readTime}}s强制阅读</el-col>
                    </el-row>
                  </template>
                  <template v-if="item.signingTipsList && item.signingTipsList.length">
                    <div v-for="(sign,i) in item.signingTipsList" :key="i">
                      <el-row v-if="sign.signatoryFullName">
                        <el-col :span="4"></el-col>
                        <el-col :span="20">指定签署方（{{sign.signatoryFullName }}）阅读并确认。</el-col>
                      </el-row>
                      <el-row v-if="sign.signingTipsTitle">
                        <el-col :span="4">签署提示标题</el-col>
                        <el-col :span="20">{{ sign.signingTipsTitle }}</el-col>
                      </el-row>
                      <el-row v-if="sign.signingTipsContent">
                        <el-col :span="4">已阅读并确认</el-col>
                        <el-col :span="20">{{ sign.signingTipsContent }}</el-col>
                      </el-row>
                    </div>
                  </template>
                </template>
                <!-- 开始签约 -->
                <template v-if="item.signType == 1">
                  <el-row>
                    <el-col :span="4">操作</el-col>
                    <el-col :span="20">登录签约中心</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">终端IP</el-col>
                    <el-col :span="20">{{ item.ip }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">签约地址</el-col>
                    <el-col :span="20">{{ item.url }}</el-col>
                  </el-row>
                  <el-row v-if="item.userAgent && item.userAgent != ''">
                    <el-col :span="4">浏览器UA</el-col>
                    <el-col :span="20">{{ item.userAgent }}</el-col>
                  </el-row>
                  <el-row v-if="item.addr">
                    <el-col :span="4">地理位置</el-col>
                    <el-col :span="20">{{ item.addr }}</el-col>
                  </el-row>
                </template>
                <!-- 完成签约 -->
                <template v-if="item.signType == 4">
                  <el-row>
                    <el-col :span="4">CA证书序列号</el-col>
                    <el-col :span="20">{{ item.signRefcode }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">CA有效期</el-col>
                    <el-col :span="20">{{ item.signStartTime }} 至 {{ item.signExpireTime }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">签署文件</el-col>
                    <el-col :span="20">{{ item.contractNames && item.contractNames.length ? item.contractNames.join(",") : contractInfo.contractName }}</el-col>
                  </el-row>
                  <el-row v-if="item.signingTipsContent">
                    <el-col :span="4">已阅读并确认</el-col>
                    <el-col :span="20">{{ item.signingTipsContent }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">存证说明</el-col>
                    <el-col :span="20" class="font-red">系统已自动将签署证据提交至第三方机构（保全中心、公证处、司法鉴定中心等）</el-col>
                  </el-row>
                </template>
                <!-- 拒签 -->
                <template v-if="item.signType == 5">
                  <el-row>
                    <el-col :span="4">时间</el-col>
                    <el-col :span="20">{{ item.createTime }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">拒签理由</el-col>
                    <el-col :span="20">{{ item.context }}</el-col>
                  </el-row>
                  <el-row v-if="item.addr">
                    <el-col :span="4">地理位置</el-col>
                    <el-col :span="20">{{ item.addr }}</el-col>
                  </el-row>
                </template>
                <!-- 删除存证 -->
                <template v-if="item.signType == 7">
                  <el-row>
                    <el-col :span="4">时间</el-col>
                    <el-col :span="20">{{ item.createTime }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"></el-col>
                    <el-col :span="20">删除{{ item.fileName }}成功，Hash值：{{ item.docHash }}</el-col>
                  </el-row>
                </template>
                <!-- 备注 -->
                <template v-else-if="item.signType == 9">
                  <el-row>
                    <el-col :span="4">时间</el-col>
                    <el-col :span="20">{{ item.createTime }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"></el-col>
                    <el-col :span="20">{{ item.context }}</el-col>
                  </el-row>
                </template>
                <!-- 签约身份认证 - 
                  2银行卡要素校验成功
                  3银行U盾 
                  10人脸识别认证 
                  15验证码认证 
                  19运营商三要素认证
                  21身份证二要素
                  22工商三要素
                  25AI鉴证
                  26视频单录
                -->
                <template v-if="[2,3,10,15,19,21,22,25,26].includes(item.signType)">
                  <el-row>
                    <el-col :span="4">认证方式</el-col>
                    <el-col :span="20" class="font-red font-bolder">
                      {{ item.signType == 26 ? item.bank : authTypeList[item.signType] }}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">认证时间</el-col>
                    <template>
                      <el-col v-if="item.signType == 25" :span="20">{{item.aiAuthTime}}</el-col>
                      <el-col v-else-if="item.signType == 26" :span="20">{{item.asrTime}}</el-col>
                      <el-col v-else :span="20">{{
                      !item.faceTime ? item.createTime : item.faceTime
                      }}</el-col>
                    </template>
                  </el-row>
                  <el-row>
                    <el-col :span="4">流水号</el-col>
                    <el-col :span="20">{{ item.orderNo }}</el-col>
                  </el-row>
                  <!-- 不同项 -->
                  <template>
                    <template v-if="item.signType == 10">
                      <el-row v-if="item.faceAuthName && item.faceAuthIdNo">
                        <el-col :span="4">授权人</el-col>
                        <el-col :span="20">{{ item.faceAuthName }}({{ item.faceAuthIdNo }})</el-col>
                      </el-row>
                      <el-row v-if="item.docHash">
                        <el-col :span="4"></el-col>
                        <el-col :span="20">
                          人脸识别视频存证成功,Hash值:{{ item.docHash }}
                        </el-col>
                      </el-row>
                    </template>
                    <!-- 银行卡要素认证取值 cardNo 字段 -->
                    <el-row v-if="item.mobile || item.cardNo">
                      <el-col :span="4">认证信息</el-col>
                      <el-col :span="20">{{ item.mobile || item.cardNo }}</el-col>
                    </el-row>
                    <template v-if="item.signType == 26">
                      <el-row>
                        <el-col :span="4">语义是否一致</el-col>
                        <el-col :span="20">是</el-col>
                      </el-row>
                    </template>
                  </template>
                  <el-row>
                    <el-col :span="4">认证结果</el-col>
                    <el-col :span="20">
                      <span class="auth-res-sty">
                        <span v-if="item.context">{{ `匹配百分比：${parseFloat(item.context).toFixed(2)}%，` }}</span>
                        <span v-if="item.similarity">{{ `${item.signType == 25 ? '人脸识别相似度' : '相似度' }：${parseFloat(item.similarity).toFixed(2)}%，` }}</span>
                        <span class="auth-statu-sty">认证通过</span>
                      </span>
                    </el-col>
                  </el-row>
                </template>
                <!-- 上传附件 -->
                <template v-if="item.signType == 11">
                  <el-row>
                    <el-col :span="4">材料名称：</el-col>
                    <el-col :span="20">{{ item.fileName }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">Hash值：</el-col>
                    <el-col :span="20">{{ item.docHash }}</el-col>
                  </el-row>
                </template>
                <!-- 转签 -->
                <template v-if="item.signType == 12">
                  <el-row>
                    <el-col :span="4">时间</el-col>
                    <el-col :span="20">{{ item.createTime }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"></el-col>
                    <el-col :span="20">{{ item.context }}</el-col>
                  </el-row>
                </template>
                <!-- 顺序签 -->
                <template v-if="item.signType == 13">
                  <el-row>
                    <el-col :span="4">时间</el-col>
                    <el-col :span="20">{{ item.createTime }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"></el-col>
                    <el-col :span="20">本次签署为连续签署，上一份签署【{{item.context}}】已完成签署并记录签署日志
                      （连续签署必须按照顺序依次连续完成签署，不可中途中断签署或跳过第一份文件进行签署，
                      身份验证适用于每一份连续签署）。</el-col>
                  </el-row>
                </template>
                <!-- 发起撤销 -->
                <template v-if="+item.signType === 16">
                  <el-row>
                    <el-col :span="4">时间</el-col>
                    <el-col :span="20">{{ item.createTime }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">终端IP</el-col>
                    <el-col :span="20">{{ item.ip }}</el-col>
                  </el-row>
                  <el-row v-if="item.userAgent && item.userAgent != ''">
                    <el-col :span="4">浏览器UA</el-col>
                    <el-col :span="20">{{ item.userAgent }}</el-col>
                  </el-row>
                  <el-row v-if="item.addr">
                    <el-col :span="4">地理位置</el-col>
                    <el-col :span="20">{{ item.addr }}</el-col>
                  </el-row>
                </template>
                <!-- 保管函 -->
                <template v-if="item.signType == 17">
                  <el-row>
                    <el-col :span="4">时间</el-col>
                    <el-col :span="20">{{ item.createTime }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">编号</el-col>
                    <el-col :span="20">{{ getId(item.safeKeepLetterId) }}</el-col>
                  </el-row>
                </template>
                <!-- 确认签署 -->
                <template v-if="item.signType == 18">
                  <el-row>
                    <el-col :span="4">时间</el-col>
                    <el-col :span="20">{{ item.createTime }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">终端IP</el-col>
                    <el-col :span="20">{{ item.ip }}</el-col>
                  </el-row>
                  <el-row v-if="item.addr">
                    <el-col :span="4">地理位置</el-col>
                    <el-col :span="20">{{ item.addr }}</el-col>
                  </el-row>
                  <el-row v-if="item.signingTipsContent">
                    <el-col :span="4">已阅读并确认</el-col>
                    <el-col :span="20">{{ item.signingTipsContent }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"></el-col>
                    <el-col :span="20">{{ item.name }}确认签署</el-col>
                  </el-row>
                </template>
                <!-- 催签日志 -->
                <template v-if="item.signType == 20">
                  <el-row>
                    <el-col :span="4">时间</el-col>
                    <el-col :span="20">{{ item.createTime }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">通知短信</el-col>
                    <el-col :span="20">{{ item.mobile }}</el-col>
                  </el-row>
                </template>
                <!-- 签约通知 -->
                <template v-if="item.signType === 24">
                  <el-row>
                    <el-col :span="4">发送方名称</el-col>
                    <el-col :span="20">{{ item.name }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">发送方证件号</el-col>
                    <el-col :span="20">{{ item.identityCard }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">通知发送时间</el-col>
                    <el-col :span="20">{{ item.createTime }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">接收方名称</el-col>
                    <el-col :span="20">{{ item.notify[0] ? item.notify[0].name : '' }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">接收方证件号</el-col>
                    <el-col :span="20">{{ item.notify[0] ? item.notify[0].idNo : ''}}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">接收方号码</el-col>
                    <el-col :span="20">{{ item.notify[0] ? item.notify[0].target : ''}}</el-col>
                  </el-row>
                </template>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </template>
      <!-- 最终存证 -->
      <template v-if="finalEviList.length">
        <p class="tip-title-sty">
          <span class="tip-icon"></span>
          <span class="title-sty">最终存证</span>
          <span class="line"></span>
        </p>
        <el-timeline>
          <el-timeline-item
            v-for="(evid, i) of finalEviList"
            :key="i"
          >
            <template slot="dot">
              <i class="dot-sty"></i>
            </template>
            <div class="signing-process-sty signing-evi-sty">
              <el-row class="signing-header-sty header-type-sty">
                <el-col :span="4" style="text-align: center;"><span class="header-title">{{ evid.storeType }}</span></el-col>
                <el-col :span="14">
                  <span class="font-bolder">{{ evid.name }}</span>
                  <span class="card-num-sty">{{ evid.identityCard }}</span>
                </el-col>
                <el-col :span="6" style="text-align: right;font-weight: bolder;padding-right: 20px;">{{ evid.createTime }}</el-col>
              </el-row>
              <div class="sign-content-sty">
                <el-row>
                  <el-col :span="4">{{evid.themeName ? '签约主题' : '文件名称'}}</el-col>
                  <el-col :span="20">{{
                    evid.themeName 
                    ? evid.themeName : 
                    (evid.contractNames && evid.contractNames.length 
                    ? evid.contractNames.join(",") : contractInfo.contractName) 
                    }}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">备案号</el-col>
                  <el-col :span="20">{{ evid.presId }}</el-col>
                </el-row>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </template>
    </div>
  </div>
</template>
<script>
import {
  postApplySignRecord,
  postApplySignRecordMulti,
  postCheckFilesStatus,
  ApiMethods
} from "@/assets/js/http-serve/http-methods";
import mixinsLoading from "@/mixins/loading"
  export default {
    layout: "fullpage",
    head: {
      title: "全证据链",
    },
    mixins: [mixinsLoading],
    data () {
      // 这里存放数据
      return {
        contractInfo:{},
        applySignRecord: [],
        isAttend: false, // 是否上传附件
        // 身份认证集合
        authTypeList:{
          2:'银行卡要素校验', // 这里取后端返回值。注明有这种方式
          3:'银行U盾',
          10:'人脸识别认证',
          15:'短信验证码',
          19: '运营商三要素认证',
          21: '身份证二要素验证',
          22: '工商三要素验证',
          25: 'AI鉴证',
          26: '视频单录',
        }

      }
    },
    // 方法集合
    methods: {
      /** 遍历获取签署方对应数据 */
      registShow(sign){
        const {identityCard:idNo,name} = sign;
        const registList = this.applySignRecord.filter(reco => [23].includes(reco.signType));
        // 2. 比对证件号和名称，返回对应的注册信息
        return registList.filter(r =>  r.identityCard === idNo && r.name === name)
      },
      /** 获取合同信息 */
      getContractInfo(){
        const {multi} = this.$route.query;
        const API = multi == 1 ? 'infoMulti' : 'info';
        ApiMethods.ApplySignController[API](this.$route.query).then(res=>{
          if(!res.success) { return this.$message.error(res.description)}
          this.contractInfo = res.data;
        })
      },
      /** 获取证据链信息 */
      getEvidenceChainInfo () {
        this.mixins_loadingStart("页面加载中...");
        postCheckFilesStatus(this.$route.query)
        .then(({ data }) => {
          data.multiFiles ? this.multiEvi() : this.generalEvi();
        })
        .catch(err => {
          console.error("判断合同类型信息：" + JSON.stringify(err));
        }).finally(() => {
          this.mixins_loadingClose();
        })
      },
      /** 多文件通用合同签署记录:签署合同及合同详情查看通用 */
      multiEvi(){
        this.mixins_loadingStart("正在获取合同过程证据...");
        postApplySignRecordMulti(this.$route.query)
        .then(({ data }) => {
          if (data) {
            this.applySignRecord = data;
            let arr = this.applySignRecord.filter(v => v.signType === 11);
            this.isAttend = arr.length > 0 ? true : false;
          }
        })
        .catch(err => {
          console.error("合同过程证据：" + JSON.stringify(err));
        }).finally(() => {
          this.mixins_loadingClose();
        });
      },
      /** 通用合同签署记录:签署合同及合同详情查看通用 */
      generalEvi(){
        this.mixins_loadingStart("正在获取合同过程证据...");
        postApplySignRecord(this.$route.query)
        .then(({ data }) => {
          if (data) {
            this.applySignRecord = data;
            let arr = this.applySignRecord.filter(v => v.signType === 11);
            this.isAttend = arr.length > 0 ? true : false;
          }
        })
        .catch(err => {
          console.error("合同过程证据：" + JSON.stringify(err));
        }).finally(() => {
          this.mixins_loadingClose();
        });
      },
      /** 认证方式回显 */
      fluStatus (val, userType) {
        let str = "";
        if (userType == 1) {
          switch (val) {
            case 1:
              str = "法人人脸识别认证";
              break;
            case 2:
              str = "法人银行卡四要素";
              break;
            case 4:
              str = "企业授权书认证";
              break;
            case 5:
              str = "企业ap注册自动审核";
              break;
            case 7:
              str = "企业ap注册自动审核";
              break;
            default:
              str = " CA机构认证";
              break;
          }
        } else {
          switch (val) {
            case 1:
              str = "人脸识别认证";
              break;
            case 2:
              str = "银行卡四要素";
              break;
            case 8:
              str = "运营商三要素";
              break;
            case 9:
              str = "非大陆居民手动认证";
              break;
            default:
              str = "CA机构认证";
              break;
          }
        }
        return str;
      },
      getId (id) {
        if (!id) return "";
        let res = id;
        for (let i = 0; i < 6 - id.toString().length; i++) {
          res = "0" + res;
        }
        return res;
      },
    },
    computed: {
      // 计算属性
      signatoryNotifys() {
        const typeMap = {
          1: '开始签约',
          2: '签署认证',
          3: '签署认证',
          4: '完成签约',
          5: '拒签',
          6: '存证成功',
          7: '删除存证',
          8: '保全成功',
          9: '备注',
          10: '签署认证',
          11: '附属材料',
          12: '转签',
          13: '顺序签',
          14: '创建签约',
          15: '签署认证',
          16: '合同撤销',
          17: '电子保管函',
          18: '确认签署',
          19: '签署认证',
          20: '催签日志',
          21: '签署认证',
          22: '签署认证',
          23: '注册认证信息',
          24: '签约通知',
          25: '签署认证',
          26: '签署认证',
        };
        // 注册认证信息已经在签署方展示，这里不展示
        const signPro = this.applySignRecord.filter(item=> !([8,23].includes(item.signType)));
        const LIST = signPro.reduce((list, item) => {
          const label = typeMap[item.signType];
          if (!label) return list;
            let className = '';
            switch (item.signType) {
              case 1:
                className = 'sign-begin-sty'
                break;
              case 4:
                className = 'sign-end-sty'
                break;
              case 6:
              case 3:
                className='signing-evi-sty'
                break;
              case '-1':
                // 冲
                break;
              default:
                className='signing-sty'
                break;
            }
            list.push({ ...item, label,className, });
          return list;
        }, []);
        return LIST.sort((a, b) => new Date(a.createTime) - new Date(b.createTime));
      },
      // return 签署方信息
      signtorList(){
        const list = this.applySignRecord.filter(reco => [1,23].includes(reco.signType))
        const uniqueList = [...new Map(
          list.map(item => [item.identityCard, item])
        ).values()];
        return uniqueList;
      },
      // 最终存证数据
      finalEviList(){
        return this.applySignRecord.filter(v => [8].includes(v.signType))
      },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      this.getContractInfo();
      this.getEvidenceChainInfo();
    },
  }
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  @primary-icon: #b62938;
  .evi-chain-root-sty{
    width: 1032px;
    margin: 0 auto;
    .auth-res-sty{
      padding: 3px 10px;
      border-radius: 6px;
      background-color: #fdf5f5;
      .auth-statu-sty{
        color:#f49934;
      }
    }
    .chain-content-sty{
      background-color: #fff;
      padding: 10px 20px;
      .signtor-title{
        display: inline-block;
        padding: 5px 20px;
        border-radius: 6px;
      }
      .dot-sty{
        width: 1vw;
        height: 1vw;
        border: 3px solid #d70024;
        border-radius: 50%;
        background-color: #fff;
      }
      .signing-process-sty{
        border-radius: 6px;
        overflow: hidden;
        .sign-content-sty{
          background-color: #fff;
          padding: 10px;
          line-height: 2;
        }
        .signing-header-sty{
          padding: 10px 0;
          display: flex;
          align-items: center;
          .card-num-sty{
            padding: 3px;
            font-size: 12px;
            margin-left: 5px;
            border-radius: 6px;
          }
        }
      }
      // 签约类型样式
      .signing-sty{
        border: 1px solid #fbdbb8;
        border-left: 3px solid #f49934;
        .header-type-sty{
          @num-bg:#f6e9de;
          border-bottom: 1px solid #fbdbb8;
          background-color: #fdefe0;
          .header-title{
            color:#f49934;
            background-color: @num-bg;
            .signtor-title();
            .font-bolder();
          }
          .card-num-sty{
            background-color: @num-bg;
          }
        }
      }
      // 存证类型样式
      .signing-evi-sty{
        border: 1px solid #f1a7b3;
        border-left: 3px solid #d70024;
        .header-type-sty{
          @num-evi:#f7d8d7;
          border-bottom: 1px solid #f1a7b3;
          background-color: #fdf2f4;
          .header-title{
            color:#d70024;
            background-color: @num-evi;
            .signtor-title();
            .font-bolder();
          }
          .card-num-sty{
            background-color: @num-evi;
          }
        }
      }
      // 开始签约样式
      .sign-begin-sty{
        @begin-color:#afe1f9;
        border: 1px solid @begin-color;
        border-left: 3px solid #6191d2;
        .header-type-sty{
          @num-begin:#dbe7f6;
          border-bottom: 1px solid @begin-color;
          background-color: #f1f7fe;
          .header-title{
            color:#16a8ed;
            background-color: @num-begin;
            .signtor-title();
            .font-bolder();
          }
          .card-num-sty{
            background-color: @num-begin;
          }
        }
      }
      // 签约完成样式
      .sign-end-sty{
        @end-color:#ceeabf;
        border: 1px solid @end-color;
        border-left: 3px solid #73c248;
        .header-type-sty{
          @num-end:#e4f6d5;
          border-bottom: 1px solid @end-color;
          background-color: #f8ffef;
          .header-title{
            color:#73c248;
            background-color: @num-end;
            .signtor-title();
            .font-bolder();
          }
          .card-num-sty{
            background-color: @num-end;
          }
        }
      }
      .signatory-sty{
        display: grid;
        /* 每列最小宽度 150px，自动填充，平均分配剩余空间 */
        grid-template-columns: 1fr 1fr;
        gap: 16px; /* 行列间距 */
        padding: 16px 0;
        .signatory-item-sty{
          padding: 10px;
          border: 1px solid #d196a0;
          border-radius: 6px;
          background-color: #fff;
          .title-ii-sty{
            font-weight: bolder;
            margin: 10px 0;
          }
          .sign-info-sty{
            line-height: 2;
          }
          .type-header-sty{
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #d196a0;
            .type-icon-sty{
              width: 3vw;
              height: 3vw;
              color:#fff;
              font-weight: bolder;
              border-radius: 50%;
              margin-right: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .person-sty{
              background: radial-gradient(
                circle at 30% 30%,
                #5bb8f0 0%,      /* 高光区：亮蓝色 */
                #1293d0 50%,     /* 主色：你指定的 #1293d0 */
                #0a5c82 100%     /* 暗部：深蓝色 */
              );
              box-shadow: 0 8px 24px rgba(18, 147, 208, 0.4),inset 0 -4px 12px rgba(0, 0, 0, 0.3);
            }
            .ent-sty{
              background: radial-gradient(
                circle at 30% 30%,        /* 高光位置：左上偏移 */
                #ff4d4d 0%,              /* 高光区：亮红色 */
                #bd0020 50%,             /* 主色 */
                #6b0012 100%             /* 暗部：深红色，制造立体感 */
              );
              box-shadow: 
                0 8px 24px rgba(189, 0, 32, 0.4),  /* 外发光，让球体更透 */
                inset 0 -4px 12px rgba(0, 0, 0, 0.3); /* 内阴影，加强底部暗部 */
            }
          }
        }
      }
      .info-sty{
        display: flex;
        flex-wrap: wrap;
        border-radius: 6px;
        border: 1px solid #d196a0;
        background-color: #fdf5f5;
        padding: 10px 20px 0 20px;
        &:not(:last-child){
          margin-bottom: 20px;
        }
        >p{
          width: 50%;
          display: flex;
          margin-bottom: 20px;
          >span:first-child{
            display: inline-block;
            width: 100px;
            flex-shrink: 0;
          }
          >span:last-child{
            display: inline-block;
            flex: 1;
          }
        } 
      }
      .tip-title-sty{
        display: flex;
        align-items: center;
        margin: 15px 0;
        .title-sty{
          color:@primary-icon;
          margin: 0 5px;
          font-size: 1.2vw;
          font-weight: bolder;
        }
        .tip-icon{
          display: inline-block;
          width: 5px;
          height: 30px;
          margin-right: 5px;
          background-color: @primary-icon;
          border-radius: 6px;
        }
        .line{
          display: inline-block;
          flex: 1;
          height: 5px;
          background-image: linear-gradient(to right,#eb808f 0%,#f1dfe2 50%,transparent 100%,);
        }
      }
    }
    .chain-header{
      height: 20vh;
      min-height: 180px;
      color: #fff;
      padding: 10px 20px;
      position: relative;
      background-image: linear-gradient(to right,#920018 0%,#d60024 50%,#920018 100%);
      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 5px;
        /* 底部边框的渐变（从左到右：红 → 紫 → 红） */
        background: linear-gradient(to right,#f49834 0%,#e1334b 50%,#f49834 100%);
      }
      .logo-img-sty{
        margin: 10px;
        width: 160px;
      }
      > h1{
        margin: 10px 0;
        font-size: 2vw;
        font-weight: bolder;
      }
    }
    .font-red{
      color: #d70024;
    }
    .font-bolder{
      font-weight: bolder;
    }
  }
  /deep/.el-timeline-item__tail{
    border-left: 3px solid @primary-icon;
  }
  /deep/.el-timeline-item__dot{
    left: -7px;
  }
</style>


// WEBPACK FOOTER //
// pages/applySign/fullEvidenceChain.vue